// src/router/index.js
import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  // mode: 'history', // 去掉 # 号，
  routes: [
    {
      path: "/paymentAgreement",
      component: () => import("@/views/agreement/paymentAgreement/index.vue"),
      meta: {
        title: "支付协议",
      },
    },
    {
      path: "/privacyPolicy",
      component: () => import("@/views/agreement/privacyPolicy/index.vue"),
      meta: {
        title: "隐私政策",
      },
    },
    {
      path: "/privacyPolicy/sdk",
      component: () => import("@/views/agreement/sdk/index.vue"),
      meta: {
        title: "聚选通第三方sdk目录",
      },
    },
    {
      path: "/userAgreement",
      component: () => import("@/views/agreement/userAgreement/index.vue"),
      meta: {
        title: "用户协议",
      },
    },
    {
      path: "/merchantAgreement",
      component: () => import("@/views/agreement/merchantAgreement/index.vue"),
      meta: {
        title: "商家协议",
      },
    },
    {
      path: "/realName",
      component: () => import("@/views/agreement/realName/index.vue"),
      meta: {
        title: "实名认证服务协议",
      },
    },
    {
      path: "/share/general",
      component: () => import("@/views/share/general/index.vue"),
      meta: {
        title: "聚选通",
      },
    },
    {
      path: "/share/download",
      component: () => import("@/views/share/download/index.vue"),
      meta: {
        title: "聚选通",
      },
    },
    {
      path: "/download",
      component: () => import("@/views/share/download/landing.vue"),
      meta: {
        title: "下载聚选通",
      },
    },
    {
      path: "/certification",
      component: () => import("@/views/certification/index.vue"),
      meta: {
        title: "实名认证",
      },
    },
    {
      path: "/certification/success",
      component: () => import("@/views/certification/success.vue"),
      meta: {
        title: "认证成功",
      },
    },
    {
      path: "/certification/fail",
      component: () => import("@/views/certification/fail.vue"),
      meta: {
        title: "认证失败",
      },
    },
    {
      path: "/statisticalRules",
      component: () => import("@/views/agreement/statisticalRules/index.vue"),
      meta: {
        title: "统计规则",
      },
    },
    {
      path: "/captcha",
      component: () => import("@/views/captcha/index.vue"),
      meta: {
        title: "安全验证",
      },
    },
    {
      path: "/qualification",
      component: () => import("@/views/store/qualification/index.vue"),
      meta: {
        title: "资质照片",
      },
    },
  ],
});

// 添加全局前置守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title; // 可以添加后缀
  } else {
    document.title = "聚选通"; // 默认标题
  }
  next();
});

export default router;
